import React from 'react';
import { LanguageIcon } from '@heroicons/react/24/outline';

const LanguageDemo = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mt-8">
      <div className="flex items-center mb-4">
        <LanguageIcon className="h-6 w-6 text-primary-600 mr-2" />
        <h2 className="text-lg font-semibold text-gray-900">Multilingual Receipt Support</h2>
      </div>
      
      <p className="text-gray-600 mb-4">
        You can now generate rent receipts in multiple languages. Currently supported languages:
      </p>
      
      <div className="flex flex-wrap gap-4 mb-6">
        <div className="flex items-center p-3 bg-blue-50 rounded-lg">
          <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center mr-2">
            <span className="text-blue-700 font-bold">EN</span>
          </div>
          <div>
            <p className="font-medium text-gray-900">English</p>
            <p className="text-sm text-gray-500">Default language</p>
          </div>
        </div>
        
        <div className="flex items-center p-3 bg-blue-50 rounded-lg">
          <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center mr-2">
            <span className="text-blue-700 font-bold">FR</span>
          </div>
          <div>
            <p className="font-medium text-gray-900">French</p>
            <p className="text-sm text-gray-500">Fully supported</p>
          </div>
        </div>
      </div>
      
      <div className="mt-4 text-sm text-gray-600">
        <p>When generating a receipt, simply select your preferred language from the dropdown menu.</p>
      </div>
    </div>
  );
};

export default LanguageDemo;